module.exports = "/_next/static/images/gpm-img3-235d9400a44f8915f113da4487c6f030.png.webp";